import { render, staticRenderFns } from "./ChipsList.vue?vue&type=template&id=c84d30c4"
import script from "./ChipsList.vue?vue&type=script&lang=js"
export * from "./ChipsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports